// removed by extract-text-webpack-plugin
module.exports = {"navigationControlBtns":"map-module__navigationControlBtns___2rBWn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map/map.module.scss
// module id = 865
// module chunks = 0